export default {
  add_user: "Cadastrar usuário",
  update_user: "Atualizar usuário",
  list_users: "Lista de usuários",
  user_data: "Dados do usuário",
  unities_profiles: "Unidades e perfis",
  remove_user_unity: "Remover unidade",
  about_to_remove_user_unity:
    "Você está prestes a remover a unidade vinculada ao usuário",
};
